/**
 * Urlフォーマット
 */
export default class UrlFormatter {
  /**
   * フォーマット
   *
   * 渡されたUrl文字列の「{paramName}」を置換する
   * 置換対象はparamsの中のkey名から動的に作成され、valueの値で置換する
   */
  public static format(url: string, params: object) {
    let formatedUrl: string = url;

    for (const [key, value] of Object.entries(params)) {
      const keyName: string = `{${key}}`;
      formatedUrl = formatedUrl.replace(keyName, value);
    }

    return formatedUrl;
  }
}
